import React from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import { PresentationListItem } from './PresentationListItem';
import { PresentationComponentInterface } from '../../../../../../../interfaces/pagebuilder';
import { RootState } from '../../../../../../../reduxToolkit/store';

const PresentationList = ({ uiComponent }: { uiComponent?: PresentationComponentInterface }) => {
  const { event, slots } = useSelector(
    ({ common }: RootState) => ({ event: common.event, slots: common.slots, favoriteSlots: common.favoriteSlots }),
    shallowEqual
  );

  if (!event) return <></>;

  return (
    <div className="w-full flex flex-col space-y-4">
      <div className="flex flex-col justify-center w-full">
        {slots
          .filter(
            (slot) =>
              !uiComponent?.selectedPresentations || uiComponent.selectedPresentations.length === 0 || uiComponent?.selectedPresentations.includes(slot._id)
          )
          .map((slot, index) => (
            <PresentationListItem slot={slot} index={index} textColor={uiComponent?.styling?.textColor} />
          ))}
      </div>
    </div>
  );
};

export default PresentationList;
